import React, { useContext, useState } from 'react';
import {
  Grid,
  IconButton,
  TextField,
} from '@material-ui/core';

import {
  Delete,
//  Edit
} from '@material-ui/icons';

import moment from 'moment';

import PropTypes from 'prop-types';

import AlertDialog from '../modals/alertDialog';
import SpinnerLoading from '../feedback/spinnerLoading';

import { removeEvent } from '../../utils/comms';

import translations from '../../languages/i18n';

import { SessionContext } from '../../utils/context';

export default function EventInfo({ description, idUser, /* handleEditEvent,*/ handleFeedback, managedBy, patientEventData, userType }) {
  const sessionContext = useContext(SessionContext);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  // ATENCIÓ: el servidor només té implementada la creació i eliminació d'esdeveniments.
  // De moment (25/09/20) aquesta funció no fa res, la deix al codi per si en un futur la necessit
  // const editEvent = (id) => {
  //  handleEditEvent(id);
  // };

  const deleteEvent = async () => {
    setShowLoading(true);
    const response = await removeEvent(idUser, patientEventData._id, sessionContext.userToken);
    setShowLoading(false);
    if (response.status === 200) { // Tenim llistat
      handleFeedback('success', 'DeleteEventFromPatient', true);
    } else if (response === 'timeOut') { // El servidor està caigut o l'usuari no té connexió
      handleFeedback('error', 'TimeOut');
    } else if (response === 409) { // No es pot esborrar l'event perque té userSchedules amb resultats
      handleFeedback('error', 'DeleteEventFromPatientNotAllowed', false);
    } else { // Altres tipus d'error
      handleFeedback('error', 'DeleteEventFromPatient', false);
    }
  };

  // Els usaris de tipus clinic Basic i clinic Administrator no poden eliminar events
  // En cas de que no sigui ni clinic Basic ni clinic Administrador, només es poden eliminar els events que es gestionen des de ICHOM_web
  // Si està gestionat per ICHOM_web tornam disableItem com a false
  const disableIcon = (userType, managedBy) => {
    if (userType === 'Basic' || userType === 'Administrator') return true;
    return !managedBy.some((manager) => manager === 'ICHOM_web');    
  };

  const manageDeleteAlertAnswer = (agree) => {
    setShowDeleteAlert(false);
    if (agree) deleteEvent();
  };

  return (
    <React.Fragment>
      <SpinnerLoading show={showLoading} />
      <AlertDialog open={showDeleteAlert} handleClose={(agree) => manageDeleteAlertAnswer(agree)} title={translations['_deleteEventAlertTitle']} message={translations['_deleteEventAlertMessage']} data={[{ desc: description }]} field='desc' />
      <Grid container spacing={2} justify='flex-start' alignItems='center'>
        <Grid item xs={5}>
          <TextField
            fullWidth
            disabled
            label={translations['_eventType']}
            variant='outlined'
            type='text'
            value={description}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            disabled
            label={translations['_eventTypeDate']}
            variant='outlined'
            type='date'
            value={patientEventData.date && moment(patientEventData.date).format('YYYY-MM-DD')} // Per adequar el format de la data al que necessita el TextField
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item>
          <Grid container justify='flex-start' direction='row'>
            {/* <Grid item>
              <IconButton onClick={() => editEvent(patientEventData._id)}><Edit /></IconButton>
            </Grid> */}
            <Grid item>
              {/* Si el clínic es de tipus bàsic o l'administrador del programa no pot eliminar events */}
              {/* TODO: decidir què fer amb l'usuari Admin */}
              <IconButton onClick={() => setShowDeleteAlert(true)} disabled={disableIcon(userType, managedBy)}><Delete /></IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

// Indica i controla els props que se han de passar al component
EventInfo.propTypes = {
  description: PropTypes.string.isRequired,
  idUser: PropTypes.string.isRequired,
  // handleEditEvent: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  managedBy: PropTypes.array.isRequired,
  patientEventData: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
};
